import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    connect() {
        this.adjustColumns();
    }

    adjustColumns() {
        const bulletPoints = this.element.querySelectorAll('li').length;
        
        if (bulletPoints > 5) {
            this.element.classList.add('md:columns-2');
        }
    }
}
